<template>
  <div class="list-by-date">
    <div class="results__input-date">
      <input
        v-model="filterDate"
        type="date"
        class="form-control"
        placeholder="dd-mm-yyyy"
        v-on:change="dateChanged"
        :max="maxDate"
      />
    </div>
    <template v-if="!isLoading">
      <v-result-details :drawResults="accountPastResults"></v-result-details>
      <div v-if="isLoadMore" class="list-by-date__load-more">
        <button @click="handleLoadMore()">LOAD MORE</button>
      </div>
    </template>
    <template v-if="isLoading">
      <loading />
    </template>
  </div>
</template>
<script>
import Details from "./details";
import moment from "moment";
import Loading from '@/components/common/loading/Loading.vue'

export default {
    components: {
      'v-result-details': Details,
      Loading
    },
    data () {
      const now = new Date();

      return {
        filterDate: '',
        countItems: 10,
        maxDate: moment(now).format('YYYY-MM-DD'),
        isLoading: true,
        isLoadMore: true
      }
    },
    watch: {
      accountPastResults: function(val) {
        if(val.length > 0)  {
          this.isLoading = false
        }
        this.isLoadMore = val.length < this.$store.getters.getPastDrawResults.length;
      }
    },
    computed: {
      accountPastResults: function () {
        return this.fnPastResults()
      }
    },
    methods: {
      getInitialLoad() {
        this.$store.dispatch('apiGetGames').then(() => {
          this.$store.dispatch('apiGetResults', {drawDate: this.filterDate})
        })
      },
      fnPastResults: function() {
        let data = this.$store.getters.getPastDrawResults;
        if(data.length !== undefined && data.length > 0) {
          data.forEach(item => {
            item.srcLogo = item.logo.split('flags-v2/').pop().replace(".svg", ".png")
          })
          return data.filter((game, index) => index < this.countItems)
        }
        return this.$store.getters.getPastDrawResults
      },
      getNextBatch() {
        let data = this.$store.getters.getPastDrawResults;
        this.countItems = this.countItems + 10
        return data.filter((game, index) => index < this.countItems)
      },
      dateChanged: function () {
        this.countItems = 10
        this.isLoading = true
        this.$store.dispatch('apiGetResults', {drawDate: this.filterDate})
      },
      handleLoadMore() {
        this.getNextBatch();
      },
    },
    beforeMount() {
      this.getInitialLoad();
    }
  }
</script>
<style scoped lang="scss" src="@/assets/scss/results/listByDate.scss"/>
